<template>
  <div class="switcher-container is-relative is-inline-block">
    <slot name="label">
      <label v-if="pLabel != null" @click="toggleValue" class="is-inline-block mr-2">{{ pLabel }}</label>
    </slot>
    <label class="switch switch-label" :class="{ 'is-disabled': pDisabled }">
      <input type="checkbox" v-e2e="'trf-switcher'" :checked="value" :disabled="pDisabled" v-model="value" @input="emitValueChange" />
      <span class="slider round"></span>
    </label>
    <i v-if="hasTip" class="fa fa-question-circle is-size-6 help-switch" :title="pTip"></i>
  </div>
</template>

<script>
export default {
  name: 'TrfSwitcher',
  emits: ['update:value'],
  props: {
    pLabel: {
      type: String,
      required: false,
      default: null
    },
    pInitialValue: {
      type: Boolean,
      required: false,
      default: false
    },
    pDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    pTip: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      value: this.pInitialValue
    };
  },
  computed: {
    hasTip() {
      return this.pTip != null;
    }
  },
  methods: {
    setValue(value) {
        this.value = value;
        this.emitValueChange();
    },
    toggleValue() {
        this.value = !this.value;
        this.emitValueChange()
    },
    emitValueChange(event) {
        if (event) {
          this.value = event.target.checked;
        }
        this.$emit("update:value", this.value)
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/variables.scss';
.switch {
  position: relative;
  display: inline-block;
  width: 25px;
  height: 16px;
  margin-left: 8px;
  input {
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--primaryColor, $primary);
}

input:checked + .slider:before {
  -webkit-transform: translateX(8px);
  -ms-transform: translateX(8px);
  transform: translateX(8px);
}

.slider.round {
  border-radius: 10px;
}

.slider.round:before {
  border-radius: 50%;
}
}

.container-switch {
  margin-bottom: 20px;
  margin-top: -5px;
}

.switch-label {
  margin-bottom: 0px;
  vertical-align: middle;
}

.help-switch {
  margin-left: 8px;
  vertical-align: text-bottom;
}
.is-disabled .checkmark {
  background-color: #f5f5f5;
  border: 1px solid #f5f5f5;
}
</style>
